import __NS_DYNAMIC_REACT_CONTENT___0 from "./talkdesk-chatbot.strings/content.default.js";
import { Content, createScopedReactContentImporter } from "packages/react-content/runtime";
const NS_DYNAMIC_REACT_CONTENT_MANAGER = createScopedReactContentImporter(undefined, {
  "default": () => __NS_DYNAMIC_REACT_CONTENT___0
});
import { createElement } from 'react';
import { ChatContainer, ChatNetspendContainer, ChatDesktopIcon, ChatNetspendDesktopIcon, ChatMobileIcon, ChatNetspendMobileIcon } from './talkdesk-chatbot.ccm.css';
import { TalkdeskChatIcons, TalkdeskNetspendChatIcons } from './icons';
import { useHttpQuery } from 'packages/http-client/react';
import { createGetBrandingRequest, createGetConfigurationRequest } from 'apps/acp/packages/webapi';
import { TalkdeskChatbotPlugin } from 'packages/talkdesk-chatbot/plugin';
export const useTalkdeskChatbotAnchor = callback => {
  return {
    href: 'javascript:void(0)',
    onClick: () => {
      callback && callback();
      window.talkDeskWebChat.toggle();
    }
  };
};
export const TalkdeskCustomChatButton = ({
  leftIconColor,
  rightIconColor,
  authed
}) => {
  var _a, _b, _c;

  const netspendBrand = 'netspend_unauthenticated_default';
  const brand = useHttpQuery(createGetBrandingRequest());
  const isNetspendBrand = netspendBrand === ((_b = (_a = brand) === null || _a === void 0 ? void 0 : _a.brand) === null || _b === void 0 ? void 0 : _b.id);
  const DesktopIcon = TalkdeskChatIcons.chat;
  const MobileIcon = TalkdeskChatIcons.chatMobile;
  const NetspendIcon = TalkdeskNetspendChatIcons.chatNetspend; // reinitialize talkdesk sdk with post login touchpointid

  const {
    'talkdesk.chatbot.touchpoint.id': touchpointId
  } = useHttpQuery(createGetConfigurationRequest());

  if (!sessionStorage.getItem('td_chat_reset') && authed) {
    window.TalkdeskChatSDK = null;
    (_c = window.talkDeskWebChat) === null || _c === void 0 ? void 0 : _c.destroy();
    new TalkdeskChatbotPlugin(true, touchpointId);
    sessionStorage.setItem('td_chat_reset', 'true');
  }

  if (!authed) {
    sessionStorage.setItem('pre_login_touchpoint_id', touchpointId || '');
  }

  return createElement(Content, {
    hash: "3dfabd41078e23fb0dff3acb5eac97d3",
    devVariables: {},
    componentsAndExpressions: [() => isNetspendBrand && createElement(ChatNetspendContainer.div, {
      onClick: () => {
        window.talkDeskWebChat.toggle();
      }
    }, createElement(ChatNetspendDesktopIcon.i, null, createElement(NetspendIcon, {
      width: "31",
      height: "31"
    })), createElement(ChatNetspendMobileIcon.i, null, createElement(NetspendIcon, {
      width: "25",
      height: "25"
    }))), () => !isNetspendBrand && createElement(ChatContainer.div, {
      onClick: () => window.talkDeskWebChat.toggle()
    }, createElement(ChatDesktopIcon.i, null, createElement(DesktopIcon, {
      leftIcon: leftIconColor,
      rightIcon: rightIconColor
    })), createElement(ChatMobileIcon.i, null, createElement(MobileIcon, {
      leftIcon: leftIconColor,
      rightIcon: rightIconColor
    })))],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  });
};